import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

/**
 * Created by Ning Jiang on 11/24/2016.
 */

export class FITHSoundConfig implements ISoundConfig{

    public static instance: FITHSoundConfig = new FITHSoundConfig();

    MAIN_GAME_AMBIANCE: string = "";
    MAIN_GAME_AMBIANCE_1: string = "background-music-main";
    BONUS_GAME_AMBIANCE: string = "background-music-fs";
    BONUS_GAME_AMBIANCE_DWARF: string = "background-music-fs-dwarf";

    // Avalanche
    REELS_OUT: string = "reelsOut";
    REELS_IN: string = "reelsIn";
    SYM_LANDING_ALL: string = "symLandingAll";
    SYM_LANDING_WOOD: string = "symLandingWood";
    SYM_LANDING_WOOD_2: string = "symLandingWood2";
    GRID_DOWN: string = "gridDown";
    GRID_UP: string = "gridUp";

    // Win Count Up
    COUNT_UP: string = "countup";
    COUNT_UP_ENDS_TINY: string = "countupEndsTiny";
    COUNT_UP_ENDS_SMALL: string = "countupEndsSmall";
    COUNT_UP_ENDS_MEDIUM: string = "countupEndsMedium";
    COUNT_UP_ENDS_LARGE: string = "countupEndsLarge";

    // Wild Mining
    TEXT_SWEEP: string = "textSweep";
    SYMBOLS_SHAKE: string = "symbolsShake";
    SYMBOLS_TURN_WILD: string = "symbolsTurnWild";
    SYMBOLS_EXPLODE_BIG: string = "symbolsExplodeBig";

    // Normal Win
    SYMBOLS_EXPLODE_SMALL: string = "symbolsExplodeSmall";
    BETLINE_HIGHLIGHT: string = "betlineHighlight";

    // Big Win
    BIG_WIN_LEVEL: string = "bigwinLevel"; // using this for all big win levels 1 to 5.
    BIG_WIN_ENDS: string = "bigwinEnds";

    // xBomb Multiplier
    MULTIPLIER_FIRE_BALL: string = "multiplierFireBall";
    WILD_EXPLODE: string = "wildExplode";
    MULTIPLIER_UP: string = "multiplierUp";

    // Anticipations
    SYM_LANDING_WOOD_SINGLE: string = "symLandingWoodSingle";
    SCATTER_LANDS: string = "scatterLands";
    SCATTER_WIN: string = "scatterWin";
    SCATTER_ANTICIPATION: string = "scatterAnticipation";
    SCATTER_ANTICIPATION_FAIL: string = "scatterAnticipationFail";

    // Bonus Game
    FS_INTRO_WAGON_IN: string = "fsIntroWagonIn";
    FS_INTRO_TEXT: string = "fsIntroText";
    FS_INTRO_WAGON_OUT: string = "fsIntroWagonOut";
    CONTINUE_BUTTON: string = "continueButton";
    FS_ROW_EXPLODE: string = "fsRowExplode";
    FS_WAGON_IN: string = "fsWagonIn";
    FS_25_MULTI_ENTERS: string = "fs25MultiEnters";
    FS_100_X_ENTERS: string = "fs100xEnters";
    FS_DWARF_ENTERS: string = "fsDwarfEnters";
    FS_DWARF_ANTICIPATION: string = "fsDwarfAnticipation";
    FS_DWARF_MULTI_LANDS: string = "fsDwarfMultiLands";
    FS_DWARF_COLLECT: string = "fsDwarfCollect";
    FS_CHEST_ENTERS: string = "fsChestEnters";
    FS_CHEST_ANTICIPATION: string = "fsChestAnticipation";
    FS_REELS_SPINNING: string = "fsReelsSpinning";
    FS_REELS_LANDING: string = "fsReelsLanding";
    FS_WAGON_OUT: string = "fsWagonOut";
    FS_COIN_LANDING_TINY: string = "fsCoinLandingTiny";
    FS_COIN_LANDING_SMALL: string = "fsCoinLandingSmall";
    FS_COIN_LANDING_MEDIUM: string = "fsCoinLandingMedium";
    FS_COIN_LANDING_LARGE: string = "fsCoinLandingLarge";
    FS_COIN_LANDING_CHEST: string = "fsCoinLandingChest";
    FS_COIN_LANDING_DWARF: string = "fsCoinLandingDwarf";
    FS_SPIN_UPGRADE: string = "fsSpinUpgrade";
    FS_MULTI_LANDS_ON_COIN_TINY: string = "fsMultiLandsOnCoinTiny";
    FS_MULTI_LANDS_ON_COIN_SMALL: string = "fsMultiLandsOnCoinSmall";
    FS_MULTI_LANDS_ON_COIN_MEDIUM: string = "fsMultiLandsOnCoinMedium";
    FS_MULTI_LANDS_ON_COIN_LARGE: string = "fsMultiLandsOnCoinLarge";
    FS_MULTI_DOWN_TO_COIN: string = "fsMultiDownToCoin";
    FS_DYNAMITE_WAGON_HIGHLIGHT: string = "fsDynamiteWagoHiglight";
    FS_DYNAMITE_LANDS_ON_COIN: string = "fsDynamiteLandsOnCoin";
    FS_DYNAMITE_THROW: string = "fsDynamiteThrow";
    FS_DYNAMITE_STONE: string = "fsDynamiteStone"; // used as 1, 2, 3
    FS_DYNAMITE_CHEST: string = "fsDynamiteChest"; // used as 1, 2
    FS_COIN_HIGHLIGHT: string = "fsCoinHighlight";
    FS_MULTI_DOWN_TO_CHEST: string = "fsMultiDownToChest";
    FS_MULTI_LANDS_IN_CHEST: string = "fsMultiLandsInChest";
    FS_COIN_SWEEP: string = "fsCoinSweep";
    FS_BAG_LANDS: string = "fsBagLands";
    FS_CHEST_LANDS: string = "fsChestLands";
    FS_DWARF_LANDS: string = "fsDwarfLands";
    FS_MULTI_TO_DWARF: string = "fsMultiToDwarf";
    FS_ENDS: string = "fsEnds";
    FS_ENDS_COUNT_UP_ENDS: string = "fsEndsCountupEnds";

    // Beer Time
    BEER_TIME_START: string = "beerTimeStart";
    BEER_TIME_COUNT_UP: string = "beerTimeCountup";
    BEER_TIME_COUNT_UP_ENDS: string = "beerTimeCountupEnds";
    BEER_TIME_ENDS: string = "beerTimeEnds";
    BEER_TIME_MUSIC: string = "beerTimeMusic";
    static AS_WIN:string = "asWin";
    static AS_WIN_BIG:string = "asWinBig";

    constructor() {
        if (FITHSoundConfig.instance) {
            throw new Error("SoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}